import { ReactElement, useEffect, useState } from "react";
import Slider from "react-slick";
import { useBoolean, useSize } from "ahooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import SliderWrapper, { CarouselModal } from "./CarouselModal";
import styles from "./CarouselPage.module.scss";

interface CarouselPageProps {
  images: string[];
}

function NextArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <FontAwesomeIcon
      icon={faChevronRight}
      className={className}
      style={{
        ...style,
        color: "rgba(29, 27, 49, 0.8)",
        height: 65,
        right: "-5%",
        top: "50%",
        transform: "translateY(-50%)",
      }}
      onClick={onClick}
    />
  );
}

function PrevArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <FontAwesomeIcon
      icon={faChevronLeft}
      className={className}
      style={{
        ...style,
        color: "rgba(29, 27, 49, 0.8)",
        height: 65,
        left: "-5%",
        top: "50%",
        transform: "translateY(-50%)",
      }}
      onClick={onClick}
    />
  );
}

const renderDotsOutsideSlider = (dots: ReactElement) => {
  return (
    <div className={styles.customDotsContainer}>
      <ul className={styles.customDots}>{dots}</ul>
    </div>
  );
};

export function CarouselPage(props: CarouselPageProps) {
  const size = useSize(document.querySelector("body"));
  const [isModalOpen, { setTrue: openModal, setFalse: hideModal }] =
    useBoolean(false);
  const [currentImage, setCurrentImage] = useState<number>(0);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isModalOpen]);

  const settings = {
    dots: true,
    appendDots: renderDotsOutsideSlider,
    infinite: true,
    speed: 500,
    slidesToShow: size?.width! > 1025 ? 2 : 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: true,

    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const handleOpenModal = (index: number) => {
    setCurrentImage(index);
    openModal();
  };

  return (
    <>
      <div className={styles.carousel}>
        <div className={styles.carouselContainer}>
          <SliderWrapper {...settings}>
            {props.images
              .filter((v) => v)
              .map((image, index) => (
                <div
                  className={styles.imageWrap}
                  key={image}
                  onClick={() => {
                    size?.width! > 1025 && handleOpenModal(index);
                  }}
                >
                  <img src={image} alt={image} className={styles.image} />
                </div>
              ))}
          </SliderWrapper>
        </div>
      </div>
      {isModalOpen && (
        <CarouselModal
          images={props.images}
          currentImage={currentImage}
          closeModal={hideModal}
        />
      )}
    </>
  );
}
